import React from 'react';
import { Divider, Layout, Typography, Row, Col, Button, Card } from 'antd';
import { Image } from 'antd';
import { WhatsAppOutlined, TrophyOutlined, RocketOutlined, CodeOutlined } from '@ant-design/icons';
import { sendGAEvent } from '../../utils';

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

// Estilos reutilizáveis
const contentStyle: React.CSSProperties = {
    margin: "0 auto",
    maxWidth: "1200px",
    paddingTop: 10,
    paddingLeft: 16,
    paddingRight: 16,
};

const paragraphStyle: React.CSSProperties = {
    marginTop: "20px",
    fontSize: "16px",
    lineHeight: "1.7",
    padding: 0,
};

const HomeMainContent: React.FC = () => {
    return (
        <>
            <div style={{ background: "#f6f8fa", padding: "0 0 32px 0" }}>
                <Content style={contentStyle}>
                    <Row justify="center" gutter={[32, 32]}>
                        <Col xs={24} style={{ textAlign: "center", marginBottom: 32 }}>
                            <Title level={2} style={{ marginBottom: 16 }}>
                                Especialidades que geram resultados
                            </Title>
                            <Paragraph style={{ fontSize: 18, color: "#595959", maxWidth: 600, margin: "0 auto" }}>
                                Combinando experiência técnica sênior com visão de negócio para resolver os desafios mais críticos do seu projeto.
                            </Paragraph>
                        </Col>

                        <Col xs={24} md={8}>
                            <Card
                                style={{ height: "100%", textAlign: "center" }}
                                hoverable
                                cover={
                                    <div style={{ fontSize: 48, color: "#1677ff" }}>
                                        <RocketOutlined />
                                    </div>
                                }
                            >
                                <Card.Meta
                                    title="Performance & UX"
                                    description={
                                        <div>
                                            <Paragraph>
                                                <b>Otimização de Web Vitals</b> e gargalos técnicos para garantir conversão em períodos de pico.
                                            </Paragraph>
                                            <ul style={{ textAlign: "left", paddingLeft: 20 }}>
                                                <li>Core Web Vitals otimizados</li>
                                                <li>Bundle splitting e lazy loading</li>
                                                <li>Cache strategies avançadas</li>
                                                <li>Performance monitoring</li>
                                            </ul>
                                        </div>
                                    }
                                />
                            </Card>
                        </Col>

                        <Col xs={24} md={8}>
                            <Card
                                style={{ height: "100%", textAlign: "center" }}
                                hoverable
                                cover={
                                    <div style={{ fontSize: 48, color: "#52c41a" }}>
                                        <TrophyOutlined />
                                    </div>
                                }
                            >
                                <Card.Meta
                                    title="Liderança Técnica (Tech Lead)"
                                    description={
                                        <div>
                                            <Paragraph>
                                                <b>Mentoria de squads</b> e implementação de metodologias ágeis para entregas de alta qualidade.
                                            </Paragraph>
                                            <ul style={{ textAlign: "left", paddingLeft: 20 }}>
                                                <li>Code reviews estratégicos</li>
                                                <li>Arquitetura de sistemas</li>
                                                <li>Gestão técnica de equipes</li>
                                                <li>Processos DevOps</li>
                                            </ul>
                                        </div>
                                    }
                                />
                            </Card>
                        </Col>

                        <Col xs={24} md={8}>
                            <Card
                                style={{ height: "100%", textAlign: "center" }}
                                hoverable
                                cover={
                                    <div style={{ fontSize: 48, color: "#fa8c16" }}>
                                        <CodeOutlined />
                                    </div>
                                }
                            >
                                <Card.Meta
                                    title="Qualidade de Código & Escala"
                                    description={
                                        <div>
                                            <Paragraph>
                                                <b>Arquitetura sustentável</b> com TypeScript, Design Patterns e testes automatizados (Jest/Cypress).
                                            </Paragraph>
                                            <ul style={{ textAlign: "left", paddingLeft: 20 }}>
                                                <li>Clean Architecture</li>
                                                <li>TypeScript avançado</li>
                                                <li>Testing strategies</li>
                                                <li>CI/CD pipelines</li>
                                            </ul>
                                        </div>
                                    }
                                />
                            </Card>
                        </Col>
                    </Row>
                </Content>
            </div>

            <div style={{ background: "linear-gradient(135deg, #1677ff, #40a9ff)", padding: "48px 0" }}>
                <Content style={contentStyle}>
                    <Row justify="center">
                        <Col xs={24} md={16} style={{ textAlign: "center" }}>
                            <Card
                                style={{
                                    background: "rgba(255, 255, 255, 0.95)",
                                    border: "none",
                                    borderRadius: 12,
                                    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)"
                                }}
                            >
                                <Title level={3} style={{ color: "#1677ff", marginBottom: 16 }}>
                                    🚀 Precisa de suporte para destravar suas entregas?
                                </Title>
                                <Paragraph style={{ fontSize: 16, marginBottom: 24, color: "#595959" }}>
                                    Estou com <b>disponibilidade limitada</b> para consultorias pontuais, code reviews e resolução de problemas críticos em React/Node.
                                </Paragraph>
                                <Button
                                    type="primary"
                                    size="large"
                                    icon={<WhatsAppOutlined />}
                                    style={{
                                        background: "#25d366",
                                        borderColor: "#25d366",
                                        fontSize: 16,
                                        height: "auto",
                                        padding: "12px 24px"
                                    }}
                                    onClick={() => {
                                        sendGAEvent("click_whatsapp_urgency", {
                                            location: "urgency_cta",
                                            label: "WhatsApp Urgência"
                                        });
                                        window.open('https://wa.me/5511944487679?text=Olá Silvano! Vi seu site e preciso de suporte técnico sênior para um projeto urgente.', '_blank');
                                    }}
                                >
                                    Falar com Silvano via WhatsApp
                                </Button>
                                <div style={{ marginTop: 16, fontSize: 12, color: "#8c8c8c" }}>
                                    Resposta garantida em até 2 horas
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </Content>
            </div>

            {/* Arquitetura de Referência */}
            <div style={{ background: "#f6f8fa", borderRadius: 8, padding: "0 0 64px 0" }}>
                <Content style={contentStyle}>
                    <Row justify="center" align="middle" gutter={[0, 32]}>
                        <Col xs={24} md={16}>
                            <Title level={3} style={{ textAlign: "center", marginBottom: 32 }}>
                                🏗️ Arquitetura de Referência
                            </Title>
                            <Paragraph style={paragraphStyle}>
                                Esta arquitetura representa a <b>infraestrutura moderna e escalável</b> que implemento em projetos de alto tráfego, combinando performance, segurança e automação de ponta a ponta.
                            </Paragraph>
                        </Col>

                        <Col xs={24} md={16}>
                            <Image
                                width="100%"
                                preview={false}
                                alt="Arquitetura Frontend Escalável - Silvano Amaral"
                                src="/images/terraformando-arquitetura.svg"
                                style={{
                                    background: 'transparent'
                                }}
                            />
                        </Col>

                        <Col xs={24} md={16}>
                            <Row gutter={[24, 24]}>
                                <Col xs={24} md={12}>
                                    <Card size="small">
                                        <Card.Meta
                                            title="🚀 Performance"
                                            description="CDN global com Cloudflare + CloudFront para delivery sub-segundo, otimização automática de assets e cache inteligente."
                                        />
                                    </Card>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Card size="small">
                                        <Card.Meta
                                            title="🔒 Segurança"
                                            description="SSL/TLS gerenciado, IAM policies granulares, proteção DDoS e validação de integridade em todas as camadas."
                                        />
                                    </Card>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Card size="small">
                                        <Card.Meta
                                            title="⚡ Automação"
                                            description="CI/CD com GitHub Actions, deploy automático, rollback instantâneo e monitoramento proativo de saúde."
                                        />
                                    </Card>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Card size="small">
                                        <Card.Meta
                                            title="📊 Escalabilidade"
                                            description="Arquitetura serverless elástica, auto-scaling baseado em demanda e otimização de custos por usage."
                                        />
                                    </Card>
                                </Col>
                            </Row>

                            <Paragraph style={{ ...paragraphStyle, marginTop: 32, textAlign: "center", fontStyle: "italic" }}>
                                Resultado da minha experiência prática em <b>cloud, infraestrutura como código e desenvolvimento frontend escalável</b>.
                                Um reflexo do meu compromisso com boas práticas, segurança e alta performance em ambientes de produção críticos.
                            </Paragraph>
                        </Col>
                    </Row>
                </Content>
            </div>

            <Divider />

            {/* Seção de Certificações */}
            <div style={{ background: "#fff", padding: "0 0 48px 0" }}>
                <Content style={contentStyle}>
                    <Row justify="center">
                        <Col xs={24} style={{ textAlign: "center" }}>
                            <Title level={3} style={{ marginBottom: 32 }}>
                                🏆 Certificações & Especializações
                            </Title>
                            <Row gutter={[24, 24]} justify="center">
                                <Col xs={12} sm={8} md={6}>
                                    <Card
                                        hoverable
                                        style={{ textAlign: "center" }}
                                        bodyStyle={{ padding: "16px 8px" }}
                                    >
                                        <div style={{ fontSize: 32, marginBottom: 8 }}>⚛️</div>
                                        <Text strong>React Expert</Text>
                                        <div style={{ fontSize: 12, color: "#8c8c8c" }}>Advanced Patterns</div>
                                    </Card>
                                </Col>
                                <Col xs={12} sm={8} md={6}>
                                    <Card
                                        hoverable
                                        style={{ textAlign: "center" }}
                                        bodyStyle={{ padding: "16px 8px" }}
                                    >
                                        <div style={{ fontSize: 32, marginBottom: 8 }}>☁️</div>
                                        <Text strong>AWS S3</Text>
                                        <div style={{ fontSize: 12, color: "#8c8c8c" }}>Storage & CDN</div>
                                    </Card>
                                </Col>
                                <Col xs={12} sm={8} md={6}>
                                    <Card
                                        hoverable
                                        style={{ textAlign: "center" }}
                                        bodyStyle={{ padding: "16px 8px" }}
                                    >
                                        <div style={{ fontSize: 32, marginBottom: 8 }}>🚀</div>
                                        <Text strong>CloudFront</Text>
                                        <div style={{ fontSize: 12, color: "#8c8c8c" }}>Global CDN</div>
                                    </Card>
                                </Col>
                                <Col xs={12} sm={8} md={6}>
                                    <Card
                                        hoverable
                                        style={{ textAlign: "center" }}
                                        bodyStyle={{ padding: "16px 8px" }}
                                    >
                                        <div style={{ fontSize: 32, marginBottom: 8 }}>🏗️</div>
                                        <Text strong>Design Patterns</Text>
                                        <div style={{ fontSize: 12, color: "#8c8c8c" }}>Clean Code</div>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Content>
            </div>

            {/* Seção Final - Por que escolher */}
            <div style={{ background: "#e6f7ff", padding: "0 0 48px 0" }}>
                <Content style={contentStyle}>
                    <Row justify="center">
                        <Col xs={24} md={16} style={{ textAlign: "center" }}>
                            <Title level={3} style={{ marginBottom: 24 }}>
                                💼 Por que escolher minha consultoria?
                            </Title>
                            <Row gutter={[32, 16]}>
                                <Col xs={24} md={8}>
                                    <div style={{ marginBottom: 16 }}>
                                        <div style={{ fontSize: 32, marginBottom: 8 }}>⚡</div>
                                        <Text strong>Resultados Imediatos</Text>
                                        <Paragraph style={{ fontSize: 14, margin: "8px 0 0 0" }}>
                                            Soluções práticas que impactam a performance do seu negócio desde o primeiro dia.
                                        </Paragraph>
                                    </div>
                                </Col>
                                <Col xs={24} md={8}>
                                    <div style={{ marginBottom: 16 }}>
                                        <div style={{ fontSize: 32, marginBottom: 8 }}>🎯</div>
                                        <Text strong>Experiência Real</Text>
                                        <Paragraph style={{ fontSize: 14, margin: "8px 0 0 0" }}>
                                            Cases reais em e-commerce de milhões de acessos simultâneos e alta conversão.
                                        </Paragraph>
                                    </div>
                                </Col>
                                <Col xs={24} md={8}>
                                    <div style={{ marginBottom: 16 }}>
                                        <div style={{ fontSize: 32, marginBottom: 8 }}>🛡️</div>
                                        <Text strong>Padrões Enterprise</Text>
                                        <Paragraph style={{ fontSize: 14, margin: "8px 0 0 0" }}>
                                            Metodologias e arquiteturas testadas em ambientes de produção críticos.
                                        </Paragraph>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Content>
            </div>
        </>
    );
};

export default HomeMainContent;